import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTable-root': {
      border: 'solid 1px rgba(109, 114, 120, 0.18)',
      borderRadius: 4,
    },
    '& .MuiTableRow-head th:first-child': {
      borderTopLeftRadius: 4,
    },
    '& .MuiTableRow-head th:last-child': {
      borderTopRightRadius: 4,
      width: 145,
    },
  },
  actionButton: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse'
    },
  },
  filterbtn: {
    flex: '11'
  },
  addUserBtn: {
    display: 'flex',
    flex: '2.1',
    [theme.breakpoints.down('lg')]: {
      flex:'3',
    },
    [theme.breakpoints.down('md')]: {
      flex:'5',
    },
    '& button': {
      flex:'1',
      [theme.breakpoints.down('sm')]: {
        flex:'1',
        marginBottom:'4px',
      },
    }
  },
  expandBtn: {
    border: `1px solid #2b3990`,
    padding: theme.spacing(2),
    margin: 0,
    background: 'white',
    color: '#2b3990',
    '&:hover': {
      background: '#2b3990',
      color: '#fff'
    }
  },
  props: {
    padding: theme.spacing(2, 3),
    boxSizing: 'border-box',
  },
  tickIcon: {
    color: '#43A047',
    fontSize: 17,
  },
  tickItem: {
    marginBottom: theme.spacing(1),
  },
  propsTitle: {
    color: '#2b3940',
    fontWeight: 'bold',
    fontSize: 12,
    marginBottom: theme.spacing(1.5),
  },
  tickText: {
    fontSize: 12,
    fontWeight: 'normal',
    marginInlineStart: theme.spacing(1),
    color: '#2b3940',
  },
  info: {
    borderRadius: 4,
    padding: theme.spacing(1.5),
  },
  detail: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
  },
  detailTitle: {
    fontSize: 12,
    color: '#546e7a',
    marginBottom: theme.spacing(1),
  },
  detailValue: {
    fontSize: 14,
    color: '#003a52',
    marginBottom: theme.spacing(0.5),
  },
  dgAddUserLoading: {
    display: 'flex',
    minHeight: '200px',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));
